import './styles/Footer.css'

export const Footer = () => {
    return (
        <footer className='footer-section'>
            <p>Designed and Built by Paulev</p>
        </footer>
    )
}